export enum AppStatus {
  loading = 'loading',
  success = 'success',
  idle = 'idle',
}
